/**
 * Die Version, die in jede Beglaubigung geschrieben wird: Hauptversion.Unterversion aus
 * `package.json`, an dritter Stelle die Zahl der Commits bis HEAD — z.B. 0.1.133. Von Vite
 * eingespritzt (`vite.config.ts`); Xcode setzt dieselbe Zahl beim Bauen (Phase „Version aus
 * git“), damit App, App Store und git eine Fassung gleich nennen (Vorgabe des Nutzers,
 * 2026-10-15). Von Hand geändert wird nur 0.1 → 0.2, in `package.json` und Xcode
 * (`MARKETING_VERSION`); `appVersion.test.ts` hält beide zusammen.
 */
export const APP_VERSION = __APP_VERSION__;

/** Die Build-Nummer — dieselbe Commit-Zahl, in Xcode `CFBundleVersion`. */
export const APP_BUILD = __APP_BUILD__;

/** Was Relay als `appVersion` bekommt, auf jeder Plattform gleich: „0.1.133 (133)“. */
export const APP_VERSION_MIT_BUILD = APP_VERSION + ' (' + APP_BUILD + ')';

/**
 * Wann dieser Bau entstanden ist, als ISO-Zeichenkette — von Vite eingespritzt
 * (`vite.config.ts`, `define`).
 *
 * Steht mit der Fassungsnummer in den iPad-Einstellungen. Zwei Bauten können dieselbe Nummer
 * tragen; dann sagt nur das Datum, welcher auf dem Gerät liegt.
 */
export const BUILD_DATE = __BUILD_DATE__;

/**
 * Das Baudatum, wie es in den Einstellungen und auf Beschriftungen erscheint:
 * `TT.MM.JJJJ, HH:MM`.
 *
 * Bewusst mit fester Reihenfolge statt `toLocaleString()`: der Wert wandert in die
 * iOS-Einstellungen und auf Bilder, die als Beleg dienen. Was dort steht, soll nicht davon
 * abhängen, welche Sprache das Gerät gerade führt.
 */
export function formatiereZeitpunkt(wert: string | number | Date = BUILD_DATE): string {
  const d = wert instanceof Date ? wert : new Date(wert);
  if (Number.isNaN(d.getTime())) return '—';
  const p = (v: number) => String(v).padStart(2, '0');
  return (
    p(d.getDate()) + '.' + p(d.getMonth() + 1) + '.' + d.getFullYear() +
    ', ' + p(d.getHours()) + ':' + p(d.getMinutes())
  );
}

/**
 * Der in den Einstellungen vergebene Gerätename.
 *
 * Über einen Setzer und nicht durch einen Import des Stores: `platform/` darf nichts aus
 * `store/` holen — sonst hinge die Ablage an der Oberfläche und liesse sich nicht mehr für
 * sich prüfen. `main.tsx` meldet den Namen an, der Store hält ihn aktuell.
 */
let name = '';
/** Die Vorgabe der Plattform (`geraetename.ts`), einmal beim Start ermittelt. */
let vorgabe = '';
export const setGeraeteName = (wert: string) => {
  name = wert;
};
export const setGeraeteVorgabe = (wert: string) => {
  vorgabe = wert;
};
/** Der wirksame Name: die Einstellung `device_name`, sonst die Vorgabe der Plattform. */
export const geraeteName = () => name.trim() || vorgabe;
